import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UserTitle from '../components/user.title';
import UserSideMenu from '../components/user.side-menu';
import ReturnOrderTableHeader from './components/return.order-table-table-header';
import { UserRefundFilterChange } from '../../../store/actions';
import Pagination from 'rc-pagination';
import classNames from 'classnames';
import { API, BASE_URL } from '../../../constants';
import _ from 'lodash';
import './return.css';

export default function ReturnMain() {
    const dispatch = useDispatch();
    const filter = {
        all: 'ทั้งหมด',
        wait: { TH: 'กำลังพิจารณา', EN: 'Considering' },
        considered: { TH: 'พิจารณาแล้ว', EN: 'Considered' }
    };
    const wording = useSelector(({ language }) => language.wording);
    const currentLanguage = useSelector(({ language }) => language.currentLanguage);
    const refundFilter = useSelector(({ user }) => user.refund.filter);
    const data = useSelector(({ user }) => user.refund.data);
    const [refundData, setRefundData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;
    const [totalItems, setTotalItems] = useState(0);

    useEffect(() => {
        setRefundData(data);
        setTotalItems((data && data.length) || 0);
    }, [data]);

    useEffect(() => {
        const filtered = refundDataFilter(data, refundFilter);
        setRefundData(filtered);
        setTotalItems(filtered && filtered.length);
    }, [refundFilter]);

    const refundDataFilter = (data, _filter) => {
        if (_filter === filter.all) {
            return data;
        }
        return _.filter(data, o => o.status === _filter);
    };

    const handleCurrentPageChange = currentPage => {
        window.scrollTo(0, 0);
        setCurrentPage(currentPage);
    };

    const handleFilterChange = name => {
        setCurrentPage(1);
        dispatch(UserRefundFilterChange(name));
    }

    const CreateRefundItem = () => {
        if (refundData.length === 0) {
            return (
                <div className='col-md-12 col-xs-12 product product-grid pt-10 pb-10 ml-10 mr-10'>
                    <div className=' text-center'>
                        <div className='icon-warpper'>
                            <img src='/assets/img/sf/not-found.png' alt='not-found.png' />
                        </div>
                        <h1 className='uppercase'>{wording.usermenu.return.notFoundData}</h1>
                    </div>
                </div>
            );
        }

        return refundData
            .slice((currentPage - 1) * rowsPerPage, (currentPage - 1) * rowsPerPage + rowsPerPage)
            .map(item => {
                return (
                    <div
                        key={item.referenceNo}
                        className='content-warpper col-md-12 col-xs-12 product product-grid pt-10 pb-10 ml-10 mr-10'>
                        <div>
                            <p className='mr-10 top-detail-user'>
                                <span className='caption white mr-10'>{wording.usermenu.return.invoiceNo}</span>
                                <span className='white mr-10'>{item.referenceNo}</span>
                                <span className='caption white mr-10'>{wording.usermenu.return.refundDate}</span>
                                <span className='white mr-10'>{item.created}</span>
                            </p>
                            <p>
                                <span className='caption white mr-10'>{wording.usermenu.return.refundStatus}</span>
                                <span
                                    className={classNames(
                                        {
                                            'status-wait': item.status === filter.wait[currentLanguage],
                                            'status-considered': item.status === filter.considered[currentLanguage]
                                        },
                                        'mr-10'
                                    )}>
                                    {item.status}
                                </span>
                            </p>
                            <p>
                                <span className='caption white mr-10'>{wording.usermenu.return.refundHeader}</span>
                            </p>
                        </div>
                        <div className='table-wrap mb-30'>
                            <table className='shop_table cart table'>
                                <ReturnOrderTableHeader />
                                <tbody>
                                    {item.responseItemOrderRefund.map(product => {
                                        var consideredCheck = ["พิจารณาแล้ว", "Considered"].includes(item.status) && product.reply;
                                        return (
                                            <Fragment key={product.id}>
                                                <tr className='return_item' style={{ borderBottom: consideredCheck && "0px" }}>
                                                    <td className='product-thumbnail' rowSpan={consideredCheck ? 2: 1} style={{ borderBottom: "1px solid white" }}>
                                                        <div>
                                                            <img
                                                                src={`${API.PRODUCT_IMG_URL}${product.picture}`}
                                                                alt={product.picture}
                                                            />
                                                        </div>
                                                    </td>

                                                    <td className='product-name'>
                                                        <span className='white'>{product.productName}</span>

                                                        <ul>
                                                            {product.productSizeName !== 'N' && (
                                                                <li className='white'>
                                                                    {`${wording.usermenu.makeReturn.size}: ${product.productSizeName}`}
                                                                </li>
                                                            )}

                                                            {product.color !== null && (
                                                                <li>
                                                                    <div
                                                                        style={{ display: 'flex' }}
                                                                        className='color-select clearfix'>
                                                                        <span
                                                                            className='white'
                                                                            style={{
                                                                                marginTop: 0,
                                                                                marginRight: 4
                                                                            }}>
                                                                            {`${wording.usermenu.makeReturn.color}:`}
                                                                        </span>
                                                                        <ul className='color-swatches clearfix'>
                                                                            <li>
                                                                                <a
                                                                                    className='pointer'
                                                                                    style={{
                                                                                        backgroundColor: product.color,
                                                                                        width: 18,
                                                                                        height: 18
                                                                                    }}
                                                                                />
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </td>

                                                    <td align='center'>
                                                        <span className='amount white'>{product.amount}</span>
                                                    </td>
                                                    <td className='refund-remark'>
                                                        <span className='amount white'>{product.remark}</span>
                                                    </td>
                                                </tr>
                                                {
                                                     consideredCheck && (
                                                        <tr>
                                                            <td colSpan="3" style={{ borderTop: "none", color: product.reply === "Approve" ? "green": "red", padding: "5px" }}>
                                                                <span>{wording.usermenu.return.reply.main}: </span>
                                                                <span>{wording.usermenu.return.reply[product.reply?.toLowerCase()]} </span>
                                                                <span>({ product.reply === "Approve" ? wording.usermenu.return.reply.type[product.type?.toLowerCase()]: product.note })</span>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </Fragment>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className='row return-form'>
                            <div className='col-md-12'>
                                <div className='row'>
                                    <div className='col-md-offset-1 col-md-3 text-right'>
                                        <span className='white'>{wording.usermenu.return.details}</span>
                                    </div>
                                    <div className='col-md-6'>
                                        <textarea placeholder='' rows='3' disabled defaultValue={item.details} />
                                    </div>
                                    <div className='col-md-offset-1 col-md-3 text-right'>
                                        <span className='white'>{wording.usermenu.return.reference}</span>
                                    </div>
                                    <div className='col-md-12 mt-20'>
                                        <div className='row'>
                                            <div className='col-md-1' />
                                            {
                                                item.imageAmount ? (
                                                    <>
                                                        {
                                                            new Array(item.imageAmount).fill(0).map((value, index) => (
                                                                <div className={`col-md-${index + 3}`}>
                                                                    <div className='thumbnail'>
                                                                        <img src={`${BASE_URL}/image/refund/${item.id}/${index + 1}.jpg`} alt={`refund_${index}`} />
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </>
                                                ) : (
                                                    <>
                                                        {item.image1 && item.image1 !== '' && (
                                                            <div className='col-md-3'>
                                                                <div className='thumbnail'>
                                                                    <img src={item.image1} alt={item.image1} />
                                                                </div>
                                                            </div>
                                                        )}
                                                        {item.image2 && item.image2 !== '' && (
                                                            <div className='col-md-3'>
                                                                <div className='thumbnail'>
                                                                    <img src={item.image2} alt={item.image2} />
                                                                </div>
                                                            </div>
                                                        )}
                                                        {item.image3 && item.image3 !== '' && (
                                                            <div className='col-md-3'>
                                                                <div className='thumbnail'>
                                                                    <img src={item.image3} alt={item.image3} />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });
    };

    return (
        <div className='main-wrapper shop oh'>
            <UserTitle title={wording.usermenu.return.myReturn} />
            <section className='section-wrap pt-70 pb-40 catalogue'>
                <div className='container relative'>
                    <div className='row'>
                        <aside className='col-md-3 sidebar'>
                            <UserSideMenu />
                        </aside>
                        <div className='col-md-9 catalogue-col right mb-50 container-list-user'>
                            {data && data.length === 0 && (
                                <div className='col-md-12 col-xs-12 product product-grid pt-10 pb-10 ml-10 mr-10'>
                                    <div className=' text-center'>
                                        <div className='icon-warpper'>
                                            <img src='/assets/img/sf/not-found.png' alt='not-found.png' />
                                        </div>
                                        <h1 className='uppercase'>{wording.usermenu.return.notFoundData}</h1>
                                    </div>
                                </div>
                            )}
                            {data && data.length > 0 && (
                                <div className='shop-catalogue grid-view'>
                                    <div className='mb-20'>
                                        <ul className='nav nav-pills nav-justified list-filter-user'>
                                            <li
                                                role='presentation'
                                                className={refundFilter === filter.all ? 'active' : null}>
                                                <a
                                                    className='pointer'
                                                    onClick={() => handleFilterChange(filter.all)}>
                                                    {wording.usermenu.return.status.all}
                                                </a>
                                            </li>
                                            <li
                                                role='presentation'
                                                className={refundFilter === filter.wait[currentLanguage] ? 'active' : null}>
                                                <a
                                                    className='pointer'
                                                    onClick={() => handleFilterChange(filter.wait[currentLanguage])}>
                                                    {wording.usermenu.return.status.wait}
                                                </a>
                                            </li>
                                            <li
                                                role='presentation'
                                                className={refundFilter === filter.considered[currentLanguage] ? 'active' : null}>
                                                <a
                                                    className='pointer'
                                                    onClick={() => handleFilterChange(filter.considered[currentLanguage])}>
                                                    {wording.usermenu.return.status.considered}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='row items-grid'>{CreateRefundItem()}</div>
                                </div>
                            )}
                            {totalItems > rowsPerPage && (
                                <div className='mt-30' style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Pagination
                                        onChange={handleCurrentPageChange}
                                        current={currentPage}
                                        pageSize={rowsPerPage}
                                        total={totalItems}
                                        showTitle={false}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
